<template>
  <div>
    <h2>
      <span class="form-group">
        Welfare Discussion
        <comments field-name='heading_body_condition_scoring' :isReadOnly="isReadOnly"></comments>
      </span>
    </h2>

    <programme-input programme-slug="welfarm"></programme-input>

    <div class="clearfix" :style="{ width: widthForRow(getFieldValue('FARMS')) + 'px' }">
      <div v-for="farm in getFieldValue('FARMS')" class="farm-fields" :key="farm.id">
        <div :class="{fonterraFields: isFonterraClient && isFonterraFarm()(farm.id)}">
        <h3>{{ farm.farm_label }}</h3>

          <h3>Animal Wellbeing Farm Plans</h3>
          <div class="form-group">
            <label>
              Adverse Weather Event plan
            </label>
            <comments :field-name="`farm_${farm.id}-cd_adverse_weather_plan`" :isReadOnly="isReadOnly"></comments>
          </div>

          <div class="form-group">
            <label>
              Heat Stress Plan
            </label>
            <comments :field-name="`farm_${farm.id}-cd_heat_stress_plan`" :isReadOnly="isReadOnly"></comments>
          </div>

          <div class="form-group">
            <label>
              Genetic Improvement (AW) Plan
            </label>
            <comments :field-name="`farm_${farm.id}-cd_genetic_improve_plan`" :isReadOnly="isReadOnly"></comments>
          </div>

          <div class="form-group">
            <label>
              Off-Pasture Grazing Facility Use Plan
            </label>
            <comments :field-name="`farm_${farm.id}-cd_off_pasture_grazing_facility_use_plan`" :isReadOnly="isReadOnly"></comments>
            <p>
              If you have an off pasture facility/structure, how do you plan to
              use it? Only req'd if you intend to use it more than 8 hours a
              day, or for more than 30 days over winter.
            </p>
          </div>

        </div>
      </div>
    </div>

    <div class="clearfix" :style="{ width: widthForRow(getFieldValue('FARMS')) + 'px' }">
      <div v-for="farm in getFieldValue('FARMS')" class="farm-fields" :key="farm.id">
        <div>
          <h3>Season BCS Fees Charged</h3>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Date</th>
                <th>Description</th>
                <th>Quantity</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(bcsfee, index) in getBCSFees(farm.id)" :key="'bcsfees'+index">
                <td class="text-left">{{ bcsfee['Date'] }}</td>
                <td class="text-left">{{ bcsfee['Description'] }}</td>
                <td class="text-left">{{ bcsfee['Quanity'] }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <date-input label="Date pre-Calving BCS is expected?"
                    :field-name="`farm_${farm.id}-bcs_precalv_exp_date`"
                    :disabled="isReadOnly">
        </date-input>

        <date-input label="Date pre-Mating BCS is expected?"
                    :field-name="`farm_${farm.id}-bcs_premate_exp_date`"
                    :disabled="isReadOnly">
        </date-input>

        <div :class="{fonterraFields: isFonterraClient && isFonterraFarm()(farm.id)}">

          <number-input label="Total Number of BCS's last season?"
                        :field-name="`farm_${farm.id}-bcs_number_req_ns`"
                        :disabled="isReadOnly">
          </number-input>

          <text-input label="What was your condition score at calving?"
                        :field-name="`farm_${farm.id}-cd_bcs_season_mean`"
                        :disabled="isReadOnly">
          </text-input>

          <text-input label="Goal for Next Season"
                        :field-name="`farm_${farm.id}-cd_bcs_mean_goal`"
                        :disabled="isReadOnly">
          </text-input>

          <div class="form-group">
            <label>
              Plan to achieve BCS goal
            </label>
            <comments :field-name="`farm_${farm.id}-bcs_mean_plan`" :isReadOnly="isReadOnly"></comments>
          </div>

          <text-input label="Proportion of cows with BCS &lt; 3.5 last season"
                        :field-name="`farm_${farm.id}-cd_bcs_under_three_five`"
                        :disabled="isReadOnly">
          </text-input>

          <text-input label="Goal for next season"
                        :field-name="`farm_${farm.id}-cd_bcs_under_three_five_goal`"
                        :disabled="isReadOnly">
          </text-input>

          <div class="form-group">
            <label>
              Plan to achieve this BCS goal
            </label>
            <comments :field-name="`farm_${farm.id}-bcs_under_three_five_plan`" :isReadOnly="isReadOnly"></comments>
          </div>

        </div>
        <fieldset>
          <div :class="{fonterraFields: isFonterraClient && isFonterraFarm()(farm.id)}">

            <legend>Lame cows</legend>

            <number-input label="Number of cows treated last season?"
                          :field-name="`farm_${farm.id}-lame_cows_treated`"
                          :disabled="isReadOnly">
            </number-input>

            <div class="form-group">
              <label>Lameness rate this season (%)</label>
              <input type="text" class="form-control" :value="lamenesRateThisSeason(farm.id)" disabled>
            </div>

            <text-input label="Goal for next season (%)"
                          :field-name="`farm_${farm.id}-cd_lameness_rate_goal`"
                          :disabled="isReadOnly">
            </text-input>

            <div class="form-group">
              <label>
                Plan for Lameness Rate
              </label>
              <comments :field-name="`farm_${farm.id}-lameness_rate_plan`" :isReadOnly="isReadOnly"></comments>
            </div>
          </div>

          <text-area label="Welfare concerns/comments"
                     :field-name="`farm_${farm.id}-lame_cows_welfare_comments`"
                     :disabled="isReadOnly">
          </text-area>

          <radio-input label="Staff training - how to treat lame cows?"
                       :field-name="`farm_${farm.id}-wants_lame_treatment_training`"
                       :choices="[
                                 {value: 'Yes', display: 'Yes'},
                                 {value: 'No', display: 'No'},
                                 {value: 'Maybe', display: 'Maybe'},
                                 ]"
                       :disabled="isReadOnly">
          </radio-input>

          <discussion-points title="Lameness Discussion"
                             :comments-field="`farm_${farm.id}-lameness_discussion`"
                             points="Prevention, treatment, training, healthy hoof, regular lames, kinds of lameness">
          </discussion-points>

        </fieldset>

        <radio-input label="Interested in Tail scoring?"
                     subtext="Tail scoring is part of WelFarm"
                     :field-name="`farm_${farm.id}-wants_tail_scoring`"
                     :addComment="true"
                     :choices="[
                     {value: 'Yes', display: 'Yes'},
                     {value: 'No', display: 'No'},
                     {value: 'Maybe', display: 'Maybe'},
                     ]"
                     :disabled="isReadOnly">
        </radio-input>

      </div>
    </div>

    <div class="clearfix" :style="{ width: widthForRow(getFieldValue('FARMS')) + 'px' }">

      <div v-for="farm in getFieldValue('FARMS')" class="farm-fields" :key="farm.id">
        <div :class="{fonterraFields: isFonterraClient && isFonterraFarm()(farm.id)}">

          <h3>Season AMU {{ farm.farm_label }}</h3>

          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Class</th>
                <th>Shed mg/kg</th>
                <th>Client mg/kg</th>
                <th>Region avg. mg/kg</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(fsa, index) in getChartData('cd_farm_season_amu')[farm.id]" :key="'fsa_'+index">
                <td class="text-left">{{ fsa['class'] }}</td>
                <td class="text-left">{{ fsa['shed_mg_kg'] }}</td>
                <td class="text-left">{{ fsa['client_mg_kg'] }}</td>
                <td class="text-left">{{ fsa['region_mg_kg'] }}</td>
              </tr>
            </tbody>
          </table>

          <text-input label="Goal for Next Season"
                        :field-name="`farm_${farm.id}-cd_farm_season_total_amu_goal`"
                        :disabled="isReadOnly">
          </text-input>
          <div class="form-group">
            <label>
              Plan for AMU reduction
            </label>
            <comments :field-name="`farm_${farm.id}-amu_reduction_plan`" :isReadOnly="isReadOnly"></comments>
          </div>

        </div>
      </div>
    </div>

    <div class="clearfix">
      <h3>NSAID</h3>
      <h4 class="form-group">
        Two years NSAID usage in mg/kg
        <comments field-name='heading_two_years_nsaid' :isReadOnly="isReadOnly"></comments>
      </h4>

      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Product</th>
            <th>{{`${seasonStartYear - 2}/${seasonStartYear - 1}`}}</th>
            <th>{{`${seasonStartYear - 1}/${seasonStartYear}`}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(nsaidr, index) in nsaidData" :key="'nsaid'+index">
            <td class="text-left">{{ nsaidr['product'] }}</td>
            <td class="text-left">{{ nsaidr['season_start_1'] }}</td>
            <td class="text-left">{{ nsaidr['season_start'] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import baseComponent from '@/mixins/base_consult_component_v2'
import { BACKEND_URL } from '../../_services';

export default {
  name: 'WelfareMonitoring',
  mixins: [ baseComponent ],
  computed: {
    ...mapGetters('currentConsult', [
      'isFonterraClient',
    ]),
    nsaidData: function ()
    {
      return (this.getChartData('nsaid_data') || []).sort((a, b) => b.sort - a.sort)
    },
  },
  methods: {
    ...mapGetters('currentConsult', ['isFonterraFarm']),
    getBCSFees: function (farm_id)
    {
      return ((this.getFieldValue('CHARTS') || {}).bcs_fees || {})[farm_id] || []
    },
    lamenesRateThisSeason: function (farm_id)
    {
      let totalCowsWintered = ((this.getFieldValue('PREVIOUS_YEAR', 'AnimalNumbers') || {})[farm_id] || {}).cows_wintered_incl_r2
      let canShowLamenesRate = (this.getFieldValue('farm_'+farm_id+'-lame_cows_treated') &&
                                  totalCowsWintered && totalCowsWintered != 0)
      return (canShowLamenesRate)
        ? (( this.getFieldValue('farm_'+farm_id+'-lame_cows_treated') / totalCowsWintered ) * 100).toFixed(2) + '%'
        : ''
    },
    chartUrl: function(path){
      return `${BACKEND_URL}${path}`
    },
  }
};
</script>

<style scoped>
.farm-fields {
  float: left;
  width: 350px;
  margin-right: 3em;
}
.checkbox-label {
  font-size: 1.4em;
}
div img {
  width: 70%;
  height: 70%;
}
</style>
